import React, { Component } from 'react';
import { Row, Col, Table } from "react-bootstrap";
import { toast } from 'react-toastify';

import { CustomCard } from "../../components/Card/CustomCard";
import { BusquedaEst } from "../../funciones/EstudiantesFunction";

import { SolicitudesPendientes } from "../../funciones/ConstanciaFunction";
import SolPendientes from "./SolicitudesContent/SolPendientes";
import EstudiantesSolicitudesTable from "./SolicitudesContent/EstudiantesSolicitudesTable";


class RepSolicidudes extends Component {
    state = {
        string: "",
        preloader: "",
        estudiantes: [],
        textTabla: "Ingresa una cédula, nombre o apellido para consultar",
        cantPendientes: 0,
        pendientes: [],
        textPendiente: {
            icon: "fa fa-spinner fa-spin",
            text: "Buscando solicitudes"
        },
        pagSelect: { value: 1, label: '- 1 -' },
        pag: 1,
        paginas: 0,
    }

    constructor (props) {
        super (props);

        SolicitudesPendientes (this.props.tipo, (resp) => {
            if (resp.length === 0) {
                this.setState({
                    textPendiente: {
                        icon: "",
                        text: `No existen solicitudes de ${this.props.tipo} pendientes`
                    },
                    pendientes: resp,
                    cantPendientes: resp.length
                })
            }else{
                this.setState({
                    pendientes: resp,
                    cantPendientes: resp.length
                })
            }
        })
    }

    cambiaValor = (prop) => (event) => {
        this.setState({
            [prop]: event.target.value 
        });
    };

    enterTab = () => (e) => {
        if (e.which === 13){
            if (this.state.string === "") return null;
            this.setState ({
                estudiantes: [],
                preloader: "fa fa-spinner fa-spin"
            }, () => {
                BusquedaEst (this.state.string, (resp) => {
                    
                    if (resp.length === 0) {
                        toast.error("No se encontró ninguna coincidencia",{autoClose: 4000});
                        this.setState ({
                            preloader: "",
                            textTabla: "La búsqueda no obtuvo resultados",
                            estudiantes: []
                        })
                        return null
                    }
                    this.setState ({
                        preloader: "",
                        estudiantes: resp
                    })
                })
            })
        }
    }

    updateList = () => {
        SolicitudesPendientes (this.props.tipo, (resp) => {
            if (resp.length === 0) {
                this.setState({
                    textPendiente: {
                        icon: "",
                        text: `No existen solicitudes de ${this.props.tipo} pendientes`
                    },
                    pendientes: resp,
                    cantPendientes: resp.length
                })
            }else{
                this.setState({
                    pendientes: resp,
                    cantPendientes: resp.length
                })
            }
        })
    }

    lisPendientes = () => {
        let { textPendiente, pendientes } = this.state;

        if (pendientes.length === 0) return (
            <tr>
                <td colSpan={5} align="center"><i className={textPendiente.icon}></i> {textPendiente.text}</td>
            </tr>
        )

        return (
            pendientes.map (option => (
                <SolPendientes
                    tipo = {this.props.tipo}
                    key = {option.id}
                    datos = {option}
                    updateList = {() => { this.updateList() }}
                />
            ))
        )
    }

    lisEstudiantes = () => {
        let { estudiantes, textTabla, } = this.state;

        if(estudiantes.length === 0) {
            return (
                <tr>
                    <td colSpan={4} align="center">{textTabla}</td>
                </tr> 
            )
        }else if(estudiantes.length > 0) {
            return(
                estudiantes.map(option => (
                    <EstudiantesSolicitudesTable
                        key={option.id_estudiante}
                        data={option}
                        tipo={this.props.tipo}
                        verDatos = {(data, nombre) => {this.openModal(data, nombre)}}
                        boton = { this.state.boton }
                    />
                ))
            )
        }else{
            return (
                <tr>
                    <td colSpan={4} align="center">{textTabla}</td>
                </tr> 
            )
        }
    }

    ayuda = () => (
        <Row align="justify">
            <Col md={12}>
                En este módulo podrás generar <strong className = "text-danger">{this.props.tipo}</strong>. Para ello ingresa primero la cédula, el nombre o el apellido del estudiante.
            </Col>
            <Col md={12} className="custom-mt-10">
                Una vez seleccionado el estudiante, presiona el botón <button className="btn btn-primary btn-xs" style={{borderWidth: 1}}><i className="fa fa-file-text"></i> Imprimir</button> para generar el documento.
            </Col>
            <Col md={12} className="custom-mt-10">
                <div>Este documento genera un código de verificación.</div>
                <strong>Importante: El código de verificación del documento se actualizará cuando se genera una nueva solicitud en un día diferente y todas las solicitudes de este tipo anteriores no podrán ser validadas electrónicamente</strong>
            </Col>
        </Row>
    )

    render() {
        let { string, preloader, cantPendientes } = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        return (
            <div className="content">
                <Row>
                    <Col md={8}>
                        <div className="custom-alert-warning" style={{padding: 5}}>
                            <div><i className="fa fa-clone"></i> Solicitudes Pendientes <strong>({cantPendientes})</strong><i className={preloader}></i></div>
                        </div>
                        <div className="table-responsive custom-mt-10" style={{backgroundColor:"#FFF", overflowX:"hidden", overflowY: "auto", maxHeight: 200}}>
                            <Table striped hover bordered>
                                <tbody>
                                    <tr className="custon-back-color-warning">
                                        <td align="center" width="15%" style={styles}><strong>C.I.</strong></td>
                                        <td width="50%" style={styles}><strong>Estudiante</strong></td>
                                        <td align="center" width="35%" style={styles}><strong>Carrera</strong></td>
                                        <td align="center" width="100px" style={styles}><strong>Acciones</strong></td>
                                    </tr>
                                    {this.lisPendientes()}
                                </tbody>
                            </Table>
                        </div>

                        <div className="custom-alert-success custom-mt-10" style={{padding: 5}}>
                            <div>Búsqueda de Estudiantes <i className={preloader}></i></div>
                            <input type="text" value ={string} onChange={this.cambiaValor("string")} onBlur={this.consultaEst} onKeyPress={this.enterTab()} className="form-control" placeholder="Ingresa la C.I., nombre o apellido del estudiante"/>
                        </div>
                        <div className="table-responsive custom-mt-10" style={{backgroundColor:"#FFF"}}>
                        <Table striped hover bordered>
                            <tbody>
                                <tr className="custon-back-color">
                                    <td align="center" width="15%" style={styles}><strong>C.I.</strong></td>
                                    <td width="50%" style={styles}><strong>Estudiante</strong></td>
                                    <td align="center" width="35%" style={styles}><strong>Carrera</strong></td>
                                    <td align="center" width="100px" style={styles}><strong>Acciones</strong></td>
                                </tr>
                                {this.lisEstudiantes()}
                            </tbody>
                        </Table>
                        </div>
                    </Col>
                    <Col md={4}>
                        <div style={{borderRadius: "4px 4px",}}>
                            <CustomCard
                                styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                category={<span style={{color: "#fff"}}>{this.props.tipo}</span>}
                                color="#a80012"
                                content={this.ayuda()}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}
 
export default RepSolicidudes;


// WEBPACK FOOTER //
// ./src/views/Reportes/RepSolicitudes.jsx